import { render, staticRenderFns } from "./editradio.vue?vue&type=template&id=740ca250&scoped=true&"
import script from "./editradio.vue?vue&type=script&lang=js&"
export * from "./editradio.vue?vue&type=script&lang=js&"
import style0 from "./editradio.vue?vue&type=style&index=0&id=740ca250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ca250",
  null
  
)

export default component.exports